import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Typography } from '@/components/Typography';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import { cn } from '@/lib/cn';
import type { CmsFleetCategoryDataKeyFeature } from '@/services/cms-sdk';
export interface KeyFeaturesProps {
  keyFeatures: CmsFleetCategoryDataKeyFeature[] | undefined;
}
export function KeyFeatures(t0) {
  const $ = _c(29);
  const {
    keyFeatures
  } = t0;
  const parentRef = useRef(null);
  const childRef = useRef(null);
  const [canToggle, setCanToggle] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const countVisibleChildren = () => {
        const parent = parentRef.current;
        const child = childRef.current;
        if (!parent || !child) {
          return;
        }
        setCanToggle(child.offsetHeight > parent.offsetHeight);
      };
      countVisibleChildren();
      window.addEventListener("resize", countVisibleChildren);
      return () => {
        window.removeEventListener("resize", countVisibleChildren);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useLayoutEffect(t1, t2);
  if (!keyFeatures) {
    return null;
  }
  let t3;
  if ($[2] !== canToggle) {
    t3 = canToggle ? () => setCollapsed(_temp) : undefined;
    $[2] = canToggle;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const toggle = t3;
  let t4;
  if ($[4] !== canToggle || $[5] !== collapsed) {
    t4 = cn("w-full overflow-hidden min-h-20", {
      "cursor-pointer": canToggle,
      "h-20": collapsed
    });
    $[4] = canToggle;
    $[5] = collapsed;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== canToggle) {
    t5 = canToggle ? {
      height: 80,
      opacity: 0
    } : false;
    $[7] = canToggle;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== canToggle || $[10] !== collapsed) {
    t6 = canToggle ? {
      height: collapsed ? 80 : "auto",
      opacity: 1
    } : false;
    $[9] = canToggle;
    $[10] = collapsed;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== keyFeatures) {
    t7 = keyFeatures?.map(_temp2);
    $[12] = keyFeatures;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div className="w-full flex flex-wrap content-start gap-1.5" ref={childRef} data-testid="key-features-motion-div-child">{t7}</div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t8 || $[20] !== toggle) {
    t9 = <motion.div className={t4} initial={t5} animate={t6} layout={true} ref={parentRef} role="button" onClick={toggle} data-testid="key-features-motion-div">{t8}</motion.div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t8;
    $[20] = toggle;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== canToggle || $[23] !== collapsed || $[24] !== toggle) {
    t10 = canToggle && <button className="bg-white absolute right-0 cursor-pointer" onClick={toggle}><Typography variant="paragraph" className="underline font-bold">{collapsed ? "Read" : "Hide"} more</Typography></button>;
    $[22] = canToggle;
    $[23] = collapsed;
    $[24] = toggle;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t9) {
    t11 = <div className="relative">{t9}{t10}</div>;
    $[26] = t10;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}
function _temp2(t0, index) {
  const {
    icon,
    heading,
    style
  } = t0;
  return <div className={cn("bg-base-150 rounded-lg px-2.5 py-1.5 inline-flex flex-row h-9 items-center", {
    "bg-badge-content-secondary": style === "secondary",
    "bg-badge-content-primary": style === "primary"
  })} key={`${index}-${heading}`}><Typography variant="paragraph" className="truncate inline-flex flex-row items-center"><PhosphorIcon className="mr-2" name={icon} />{heading}</Typography></div>;
}
function _temp(prev) {
  return !prev;
}